/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanApplicationCharges { 
    id?: number;
    creditUnionChargeId?: number;
    chargeName?: string | null;
    amount?: number;
    description?: string | null;
    dueDate?: string | null;
    paymentMode?: string | null;
    status?: string | null;
    accountId?: number;
    accountName?: string | null;
    accountNumber?: string | null;
    accountCode?: string | null;
    typeId?: number | null;
    balance?: number;
}

